import { formatLength, type UnitPreference } from '@/shared/unitPresentation'

/** 同步 CAD 距离输入框在当前单位下的纯数字值。 */
export function updateCadDistanceInputPresentation(
  inputElement: HTMLInputElement,
  valueInMeters: number,
  preference: UnitPreference
): void {
  const formattedValue = formatLength(valueInMeters, preference)
  inputElement.value = formattedValue.copyText
}
